const ActivityCategory = {
    EmailFailure: 0,
    EmailSuccess: 1,
    DataManagementJob: 2,
    AutoImportJob: 3,
    AlertsJob: 4,
    DelegationsJob: 5,
    ConnectedServicesJob: 6,
    DocumentLifeCycleJob: 7,
    DocumentsWithMissingIndexesJob: 8,
    LicenseJob: 9,
    ObjectUnlockerJob: 10,
    UsedDiskSpaceJob: 11,
    DocumentAIRecognition: 12,
    DigitalSignatureFailed: 13,
    DocumentBlockedBySignatureStepJob: 14,
};
Object.entries(ActivityCategory).forEach(([key, value]) => {
    ActivityCategory[value] = key;
  });
export default ActivityCategory;